import { useSyncExternalStore } from 'react';

/**
 * The per-user mute for the new-message notification, remembered in this browser. Muted: no toast and no OS
 * notification; the Inbox badge still counts. Storage can be missing or throw (private window, blocked site
 * data): then the notification is simply not muted.
 */
export const INBOX_NOTIFY_MUTE_KEY = 'scrips.inbox.notify.muted';

const listeners = new Set<() => void>();

export function isInboxNotifyMuted(): boolean {
  try {
    return localStorage.getItem(INBOX_NOTIFY_MUTE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setInboxNotifyMuted(muted: boolean): void {
  try {
    if (muted) localStorage.setItem(INBOX_NOTIFY_MUTE_KEY, '1');
    else localStorage.removeItem(INBOX_NOTIFY_MUTE_KEY);
  } catch {
    // Not remembered; the toggle still reflects the click below.
  }
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  // Another tab changed it.
  const onStorage = (e: StorageEvent) => {
    if (e.key === INBOX_NOTIFY_MUTE_KEY) listener();
  };
  window.addEventListener('storage', onStorage);
  return () => {
    listeners.delete(listener);
    window.removeEventListener('storage', onStorage);
  };
}

export function useInboxNotifyMuted(): boolean {
  return useSyncExternalStore(subscribe, isInboxNotifyMuted, () => false);
}
